/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SavedCommodity
 */
export interface SavedCommodity {
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  savedCommodityId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SavedCommodity
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  nmfcItemNumber?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  handlingUnitType?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousUnNumber?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousClassification?: string;
  /**
   *
   * @type {boolean}
   * @memberof SavedCommodity
   */
  isDangerous?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SavedCommodity
   */
  isStackable?: boolean;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  temperatureHandling?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousPackingGroup?: string;
  /**
   *
   * @type {number}
   * @memberof SavedCommodity
   */
  dangerousNumberPackages?: number;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousPackagingType?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousProperShippingName?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dangerousTechnicalName?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  skuIdentifier?: string;
  /**
   *
   * @type {number}
   * @memberof SavedCommodity
   */
  length?: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommodity
   */
  width?: number;
  /**
   *
   * @type {number}
   * @memberof SavedCommodity
   */
  height?: number;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  dimensionsSource?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  createdSource?: string;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  shopifyVariantId?: string;
  /**
   *
   * @type {number}
   * @memberof SavedCommodity
   */
  handlingTimeBusinessDays?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SavedCommodity
   */
  shopifyProductTags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SavedCommodity
   */
  createdByName?: string;
}

/**
 * Check if a given object implements the SavedCommodity interface.
 */
export function instanceOfSavedCommodity(
  value: object,
): value is SavedCommodity {
  return true;
}

export function SavedCommodityFromJSON(json: any): SavedCommodity {
  return SavedCommodityFromJSONTyped(json, false);
}

export function SavedCommodityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedCommodity {
  if (json == null) {
    return json;
  }
  return {
    savedCommodityId:
      json["savedCommodityId"] == null ? undefined : json["savedCommodityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    nmfcItemNumber:
      json["nmfcItemNumber"] == null ? undefined : json["nmfcItemNumber"],
    description: json["description"] == null ? undefined : json["description"],
    handlingUnitType:
      json["handlingUnitType"] == null ? undefined : json["handlingUnitType"],
    dangerousUnNumber:
      json["dangerousUnNumber"] == null ? undefined : json["dangerousUnNumber"],
    dangerousClassification:
      json["dangerousClassification"] == null
        ? undefined
        : json["dangerousClassification"],
    isDangerous: json["isDangerous"] == null ? undefined : json["isDangerous"],
    isStackable: json["isStackable"] == null ? undefined : json["isStackable"],
    temperatureHandling:
      json["temperatureHandling"] == null
        ? undefined
        : json["temperatureHandling"],
    dangerousPackingGroup:
      json["dangerousPackingGroup"] == null
        ? undefined
        : json["dangerousPackingGroup"],
    dangerousNumberPackages:
      json["dangerousNumberPackages"] == null
        ? undefined
        : json["dangerousNumberPackages"],
    dangerousPackagingType:
      json["dangerousPackagingType"] == null
        ? undefined
        : json["dangerousPackagingType"],
    dangerousProperShippingName:
      json["dangerousProperShippingName"] == null
        ? undefined
        : json["dangerousProperShippingName"],
    dangerousTechnicalName:
      json["dangerousTechnicalName"] == null
        ? undefined
        : json["dangerousTechnicalName"],
    skuIdentifier:
      json["skuIdentifier"] == null ? undefined : json["skuIdentifier"],
    length: json["length"] == null ? undefined : json["length"],
    width: json["width"] == null ? undefined : json["width"],
    height: json["height"] == null ? undefined : json["height"],
    dimensionsSource:
      json["dimensionsSource"] == null ? undefined : json["dimensionsSource"],
    createdSource:
      json["createdSource"] == null ? undefined : json["createdSource"],
    shopifyVariantId:
      json["shopifyVariantId"] == null ? undefined : json["shopifyVariantId"],
    handlingTimeBusinessDays:
      json["handlingTimeBusinessDays"] == null
        ? undefined
        : json["handlingTimeBusinessDays"],
    shopifyProductTags:
      json["shopifyProductTags"] == null
        ? undefined
        : json["shopifyProductTags"],
    createdByName:
      json["createdByName"] == null ? undefined : json["createdByName"],
  };
}

export function SavedCommodityToJSON(json: any): SavedCommodity {
  return SavedCommodityToJSONTyped(json, false);
}

export function SavedCommodityToJSONTyped(
  value?: SavedCommodity | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedCommodityId: value["savedCommodityId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    nmfcItemNumber: value["nmfcItemNumber"],
    description: value["description"],
    handlingUnitType: value["handlingUnitType"],
    dangerousUnNumber: value["dangerousUnNumber"],
    dangerousClassification: value["dangerousClassification"],
    isDangerous: value["isDangerous"],
    isStackable: value["isStackable"],
    temperatureHandling: value["temperatureHandling"],
    dangerousPackingGroup: value["dangerousPackingGroup"],
    dangerousNumberPackages: value["dangerousNumberPackages"],
    dangerousPackagingType: value["dangerousPackagingType"],
    dangerousProperShippingName: value["dangerousProperShippingName"],
    dangerousTechnicalName: value["dangerousTechnicalName"],
    skuIdentifier: value["skuIdentifier"],
    length: value["length"],
    width: value["width"],
    height: value["height"],
    dimensionsSource: value["dimensionsSource"],
    createdSource: value["createdSource"],
    shopifyVariantId: value["shopifyVariantId"],
    handlingTimeBusinessDays: value["handlingTimeBusinessDays"],
    shopifyProductTags: value["shopifyProductTags"],
    createdByName: value["createdByName"],
  };
}
